module.exports = __webpack_public_path__ + "static/media/cloud-computing-2001090_1920.4e494bed.jpg";